import type { PassoJornada } from '@content/jornada.js'
import { getModulosJornada } from '@content/jornada.js'

export function passoTotalNoModulo(moduloId: string): number {
  const mod = getModulosJornada().find((m) => m.id === moduloId)
  return mod?.passos.length ?? 0
}

/** Ex.: "Terreno — etapa 3 de 15" */
export function formatPassoNoModulo(passo: PassoJornada): string {
  const total = passoTotalNoModulo(passo.moduloId)
  return `${passo.moduloTitulo} — etapa ${passo.ordemModulo} de ${total}`
}

/** Ex.: "Etapa 3 de 15" (dentro do módulo) */
export function formatPassoOrdem(passo: PassoJornada): string {
  const total = passoTotalNoModulo(passo.moduloId)
  return `Etapa ${passo.ordemModulo} de ${total}`
}
